export default function (Vue) {
    Vue.snackbar = {
        error(message) {
            // Materialize.toast('<i class="material-icons">clear</i>&nbsp ' + message, 4000, 'error');
        },
        success(message) {
            // Materialize.toast('<i class="material-icons" @click="close">check</i>&nbsp ' + message, 4000, 'success');
        },
        close() {
            // $('#toast-container').fadeOut();
        }
    };


    Object.defineProperties(Vue.prototype, {
        $snackbar: {
            get: function () {
                return Vue.snackbar;
            }
        }
    });
}


// WEBPACK FOOTER //
// ./src/packages/snackbar/index.js